const PAGE3_ABOUT = "PAGE3_ABOUT";
const PAGE3_BANNER_IMAGES = "PAGE3_BANNER_IMAGES";
const page3AboutChange = content => ({
  type: PAGE3_ABOUT,
  content: content
});

const page3IndexImgChange = photolist => {
  let photoinfo = {
    type: "image",
    photolist: photolist.map(photo => photo),
    count: photolist.length
  };
  return {
    type: PAGE3_BANNER_IMAGES,
    photoinfo: photoinfo
  };
};

export {
  PAGE3_ABOUT,
  page3AboutChange,
  PAGE3_BANNER_IMAGES,
  page3IndexImgChange
};
